import { store } from "~/state/store";
import { watch, watchUser } from "~/state/util";
import { updateDataWithBe } from "~/state/report/state";
import { CONFIG } from "~/config";
import { IUserState } from "~/state/user/interfaces";
import { getUserFeedbacks } from "~/report/provider";
import { IUserFeedbackItem } from "~/report/interfaces";
import { getId } from "~/state/report/utils";

const TIMEOUTS = {
	// 10 * 60 * 1000
	PERIOD: 10 * 60 * 1000,
};
let id = -1;

async function checkUserData() {
	const userData = store.getState().user.user;

	if (userData.state !== "green") {
		return;
	}

	const userFeedbacks = await getUserFeedbacks();
	// pouze existujici, duplicity v CR nechceme
	const pois: {[key: string]: IUserFeedbackItem; } = {};
	const filtered = userFeedbacks.filter(item => {
		const curId = getId(item.poi_source, item.poi_id);

		if (curId in pois) {
			return false;
		}

		pois[curId] = item;

		return item.poi_id && item.poi_source;
	});

	// zmeny do storu
	store.dispatch(updateDataWithBe({
		rusId: userData.rusId,
		items: filtered,
	}));
}

function checkUser(data: IUserState["user"]) {
	if (id) {
		clearInterval(id);
		id = 0;
	}

	if (data.state === "green") {
		id = setInterval(() => {
			checkUserData();
		}, TIMEOUTS.PERIOD) as unknown as number;
		checkUserData();
	}
}

export function initReportRefresh() {
	if (!CONFIG.inFrame) {
		const watcher = watch(store.getState, "user", watchUser);

		store.subscribe(watcher((newUser: IUserState) => {
			checkUser(newUser.user);
		}));

		checkUser(store.getState().user.user);
	}
}
